var l = /* @__PURE__ */ ((n) => (n.Block = "block", n.Stack = "stack", n.Inline = "inline", n))(l || {});
const c = ["stack", "block", "inline"];
export {
  c as CHECKBOX_GROUP_LAYOUTS,
  l as CheckboxGroupLayout
};
